import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.apiBaseUrl;

  getUrl(endpoint: string): string {
    return `${this.baseUrl}/${endpoint}`;
  }

  getGlobalUrl(endpoint: string): string {
    return `${this.baseUrl}/global/${endpoint}`;
  }

}
